import React from "react";
import Feedback from "../../Common/feedback/Feedback";

const FeedbackPage = () => {
  return (
    <div className="content-wrapper">
      <Feedback />
    </div>
  );
};

export default FeedbackPage;
